// extracted by mini-css-extract-plugin
export default {"clock":"clock_clock__R6Y0u"};